module.exports = __webpack_public_path__ + "img/a8723ee.jpg";